import { API_ENDPOINT } from "@/constants";
import BaseMixin from "@/mixins/http/Base";
import MultipleProduct from "@/models/Agents/MultipleProduct";
import ClientAgentProduct from "@/models/Agents/Product";
import ClientProductWithHierarchy from "@/models/Agents/ProductWithHierarchy";
import { Component } from "vue-property-decorator";

export enum AgentProductMixinTags {
  GetProducts = "get_products",
  GetProductsWithoutPrincipals = "get_products_without_principals",
  GetMultipleProductsGroupsNames = "get_multiple_products_groups_names",
  GetMultipleProductsGroupByName = "get_multiple_products_group_by_name",
  SendAlertMultipleProductsGroup = "send_alert_multiple_products_group",
}

@Component
export default class AgentProductMixin extends BaseMixin {
  getProducts(slug: string, params?: any): Promise<ClientAgentProduct[]> {
    const queryString = this.paramsToQueryString(params);
    const url = API_ENDPOINT + `/${slug}/agents/products.json?${queryString}`;

    return this.$store.dispatch("http/request", {
      tag: AgentProductMixinTags.GetProducts,
      url: url,
      method: "GET",
    });
  }

  getProductsWithHierarchy(
    slug: string,
    params?: any
  ): Promise<ClientProductWithHierarchy[]> {
    const requestParams = {
      ...params,
      "filter[with_hierarchy]": 1,
    };
    const queryString = this.paramsToQueryString(requestParams);
    const url = API_ENDPOINT + `/${slug}/agents/products.json?${queryString}`;

    return this.$store.dispatch("http/request", {
      tag: AgentProductMixinTags.GetProducts,
      url: url,
      method: "GET",
    });
  }

  getProductsWithoutPrincipals(
    tag: string,
    slug: string,
    params?: any
  ): Promise<ClientAgentProduct[]> {
    const queryString = this.paramsToQueryString(params);
    const url =
      API_ENDPOINT +
      `/${slug}/agents/products/products_without_principal.json?${queryString}`;

    return this.$store.dispatch("http/request", {
      tag: tag,
      url: url,
      method: "GET",
    });
  }

  getProductsWithoutPrincipalsWithHierarchy(
    slug: string,
    params?: any
  ): Promise<ClientProductWithHierarchy[]> {
    const requestParams = {
      ...params,
      "filter[with_hierarchy]": 1,
    };

    const queryString = this.paramsToQueryString(requestParams);
    const url =
      API_ENDPOINT +
      `/${slug}/agents/products/products_without_principal.json?${queryString}`;

    return this.$store.dispatch("http/request", {
      tag: AgentProductMixinTags.GetProductsWithoutPrincipals,
      url: url,
      method: "GET",
    });
  }

  getMultipleProductsGroupsNames(
    tag: string,
    slug: string,
    params?: any
  ): Promise<string[]> {
    const queryString = this.paramsToQueryString(params);
    const url =
      API_ENDPOINT +
      `/${slug}/agents/products/multiple_products_groups_names.json?${queryString}`;

    return this.$store.dispatch("http/request", {
      tag: tag,
      url: url,
      method: "GET",
    });
  }

  getMultipleProductsGroupByName(
    slug: string,
    params?: any
  ): Promise<MultipleProduct[]> {
    const queryString = this.paramsToQueryString(params);
    const url =
      API_ENDPOINT +
      `/${slug}/agents/products/multiple_products_group_by_name.json?${queryString}`;

    return this.$store.dispatch("http/request", {
      tag: AgentProductMixinTags.GetMultipleProductsGroupByName,
      url: url,
      method: "GET",
    });
  }

  multipleAssignPrincipal(
    ids: number[],
    slug: string,
    principalId: string,
    tag: string
  ) {
    const url =
      API_ENDPOINT + `/${slug}/agents/products/multiple_assign_principal.json`;

    const data = {
      ids,
      principalId,
    };
    return this.$store.dispatch("http/request", {
      tag: tag,
      url: url,
      method: "POST",
      data,
    });
  }

  resolveMultipleProductsGroup(
    ids: string[],
    slug: string,
    selectedProductId: string,
    selectedCompanyId: string,
    tag: string
  ) {
    const url =
      API_ENDPOINT +
      `/${slug}/agents/products/resolve_multiple_products_group.json`;

    const data = {
      multiple_products_ids: ids,
      selected_product_id: selectedProductId,
      selected_company_id: selectedCompanyId,
    };
    return this.$store.dispatch("http/request", {
      tag: tag,
      url: url,
      method: "PATCH",
      data,
    });
  }

  sendAlertMultipleProductsGroup(
    ids: string[],
    slug: string,
    groupName: string,
    tag: string
  ) {
    const url =
      API_ENDPOINT +
      `/${slug}/agents/products/send_alert_multiple_products_group.json`;

    const data = {
      multiple_products_ids: ids as string[],
      multiple_product_group_name: groupName as string,
    };
    return this.$store.dispatch("http/request", {
      tag: tag,
      url: url,
      method: "POST",
      data,
    });
  }
}
